


import { Component, Vue } from 'vue-property-decorator';
import {
    OPTIONAL_COOKIES_ACCEPTED_VALUE,
    OPTIONAL_COOKIES_KEY,
} from '../../constants';
import { GoogleTagManagerService } from '../../service/GoogleTagManagerService';
import Cookies from 'js-cookie';

@Component
export default class GoogleTagManagerHead extends Vue {
    async created() {
        GoogleTagManagerService.setupDataLayer();

        const optionalCookies = Cookies.get(OPTIONAL_COOKIES_KEY);
        if (optionalCookies !== OPTIONAL_COOKIES_ACCEPTED_VALUE) {
            return;
        }

        const googleTagManagerId =
            await GoogleTagManagerService.getGoogleTagManagerId();

        if (googleTagManagerId != null) {
            this.includeGoogleTagManagerScript(googleTagManagerId);
            GoogleTagManagerService.pushEvent({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js',
            });
        }
    }

    includeGoogleTagManagerScript(tagManagerId: string) {
        const encodedTagManagerId = encodeURIComponent(tagManagerId);
        const firstScriptTag = document.getElementsByTagName('script')[0];
        const newScriptTag = document.createElement('script');
        newScriptTag.async = true;
        newScriptTag.src = `https://www.googletagmanager.com/gtm.js?id=${encodedTagManagerId}`;
        firstScriptTag.parentNode.insertBefore(newScriptTag, firstScriptTag);
    }
}
